module.exports = __webpack_public_path__ + "img/send-document.b0cba155.svg";